export const BROWSER_ROUTES = {
	// Auth routes
	LOGIN: "/sign-in",
	SIGNUP: "/sign-up",
	SIGNUP_VERIFY_OTP: "/sign-up/verify-otp",
	SIGNUP_RESET_PASSWORD: "/sign-up/reset-password",
	VERIFY_EMAIL: "/verify-email",
	FORGET_PASSWORD: "/forget-password",
	VERIFY_OTP: "/verify-otp",
	RESET_PASSWORD: "/reset-password",
	SET_PASSWORD: "/set-password",
	UNAUTHORIZED: "/unauthorized",
	SERVER_ERROR: "/500",
	NOT_FOUND: "/404",
	ABOUT: "/about",
	// Legal routes
	PRIVACY_POLICY: "/privacy-policy",
	TERMS_AND_CONDITIONS: "/terms-and-conditions",
	// Dashboard routes
	DASHBOARD: "/",
	INSTITUTE_STATS_DASHBOARD: "/institute-stats-dashboard",
	ACADEMIC_CALENDAR: "/academic-calendar",
	ACADEMIC_CALENDAR_COURSES: "/academic-calendar/:applicationSessionUuid/courses",
	// Application routes
	APPLICATIONS: "/applications",
	ADMISSIONS: "/admissions",
	TRACK_APPLICATION: "/track-application",
	E_CHALLAN_STATUS: "/e-challan-status",
	E_CHALLAN_SUMMARY: "/e-challan-summary",
	REGISTER_INSTITUTE: "/register-institute",
	ADD_COURSES: "/add-courses",
	COURSES: "/courses",
	OPEN_ADMISSION: "/open-admission",
	MANAGE_SESSIONS: "/manage-sessions",
	COURSE_DETAILS: "/course-details",
	COURSE_DETAILS_PAGE: "/course-details-page",
	FACULTY: "/faculty",
	RENEWAL_COURSES: "/renewal-courses",
	REVIEW_APPLICATIONS: "/review-applications",
	COURSE_ATTAHMENTS: "/course-details/attachments",
	CERTIFICATE: "/certificate",
	REFERBACK: "/referback",
	ATTENDANCE: "/attendance",
	STUDENT_ATTENDANCE: "/student-attendance",
	FACULTY_ATTENDANCE: "/faculty-attendance",
	PROMOTION: "/promotion",
	DROPOUT: "/dropout",
	MIGRATION_REQUESTS: "/migration-requests",
	EMPLOYMENT_STATUS: "/employment-status",
	MANAGE_OJT: "/manage-ojt",
	MANAGE_OJT_SESSION: "/manage-ojt/:sessionUuid",
	RESULT_MANAGEMENT: "/result-management",
	SESSION_STUDENTS: "/session-students",
	STUDENT_CERTIFICATES: "/student-certificates",
	UNREGISTERED_INSTITUTES: "/institutes/unregistered",
	CERTIFICATE_VERIFICATION: "/institutes/verify",
	VIEW_CERTIFICATE: "/institutes/view-certificate",
	REPORT_UNREGISTERED_INSTITUTE: "/report-unregistered-institute",
	/** Legacy path; redirects to technical catalog. Distinct from `COURSES` (`/courses`). */
	PUBLIC_COURSE_CATALOG: "/course-catalog",
	/** Embeddable course catalog — technical stream (no auth). */
	PUBLIC_COURSE_CATALOG_TECHNICAL: "/courses-technical",
	/** Embeddable course catalog — vocational stream (no auth). */
	PUBLIC_COURSE_CATALOG_VOCATIONAL: "/courses-vocational",
} as const;

export const REGISTER_INSTITUTE_STEP_ROUTES = [
	["institute/basic-info", "institute/address-details", "institute/ownership-details"],
	["building/covered-area", "building/indoor-facilities", "building/outdoor-facilities", "building/other-facilities"],
	["attachments"],
];

export const REGISTER_COURSE_STEP_ROUTES = [
	["basic-info"], // Course Details main step
	["lab-equipment"], // Equipment Details main step
	["faculty"], // Faculty Details main step
	["attachments"], // Attachments main step
];

export const REVIEW_APPLICATION_STEP_ROUTES = [
	["personal-info"],
	["guardian-info"],
	["contact-info"],
	["address-info"],
	["qualification/matriculation", "qualification/intermidiate", "qualification/bachelor"],
];

export const EXTERNAL_LINKS = {
	LANDING_PORTAL: "https://tmis-skills.optimusfoxdev.com/",
} as const;
